import React from "react";

import Navigation from "features/new/navigation";
import Slider from "features/new/slider";

import "features/new/header/view.scss";

const HeaderView = () => (
  <header className="header">
    <Navigation />
    <Slider />
  </header>
);

export default HeaderView;
